<h2 class="no-margin-bottom">Section Validation Editor</h2>
<div class="grid-x">
  <div class="cell small-12 bold">
    Section Rules
  </div>
</div>
<div class="grid-x">
  <div class="cell small-12">
    <span class="label-text">Section:</span>
    <select id="slctSection" [(ngModel)]="selectedSection">
      @for (section of availableSections; track section) {
        <option [ngValue]="section">{{section.name}}</option>
      }
    </select>
  </div>
</div>
@if (selectedSection.id !== '-1') {
  <div class="grid-x">
    <div class="cell small-12 bold">
      Define the rule that determines when a section of the flow is required to be completed.
    </div>
    <div class="cell small-3">
      Rule Name:
    </div>
    <div class="cell small-9">
      <input type="text" [(ngModel)]="requiredRule.name" />
    </div>
    <div class="cell small-12">
      <rules-editor [(type)]="requiredRule.name" [(rule)]="requiredRule" ></rules-editor>
    </div>
  </div>
}
